import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";
import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import "./admin.css";

interface CCM {
  id: string;
  title: string;
  description: string;
  pdf_url: string;
}

export const CCMAdminPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [description, setDescription] = useState("");
  const [ccms, setCcms] = useState<CCM[]>([]);
  const [newCcm, setNewCcm] = useState<Partial<CCM>>({});

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "ccm_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setDescription(data.description || "");
        setCcms(data.ccms || []);
      }
    };
    fetchData();
  }, []);

  const handleHeaderUpload = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `ccm/header_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);

    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const handlePdfUpload = async (file: File) => {
    const storageRef = ref(storage, `ccm/pdf_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    return new Promise<string>((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        undefined,
        reject,
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        }
      );
    });
  };

  const addNewCcm = async () => {
    if (!newCcm.title || !newCcm.description || !newCcm.pdf_url) return;

    const newItem: CCM = {
      id: uuidv4(),
      title: newCcm.title,
      description: newCcm.description,
      pdf_url: newCcm.pdf_url,
    };

    setCcms((prev) => [...prev, newItem]);
    setNewCcm({});
  };

  const deleteCcm = (id: string) => {
    setCcms((prev) => prev.filter((ccm) => ccm.id !== id));
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "ccm_page"), {
      header_image: headerImage,
      description,
      ccms,
    });
    alert("Salvat cu succes!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Pagina CCM</h1>

      <label>Imagine Banner:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setHeaderFile(e.target.files?.[0] || null)}
      />
      <button onClick={handleHeaderUpload}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <label>Descriere:</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Descrierea generală pentru pagina CCM"
      />

      <hr />

      <h2>CCM-uri existente</h2>
      {ccms.map((ccm) => (
        <div key={ccm.id} className="law-item">
          <strong>{ccm.title}</strong>
          <p>{ccm.description}</p>
          <a href={ccm.pdf_url} target="_blank" rel="noreferrer">PDF</a>
          <button onClick={() => deleteCcm(ccm.id)}>Șterge</button>
        </div>
      ))}

      <hr />
      <h2>Adaugă CCM nou</h2>
      <input
        type="text"
        placeholder="Titlu"
        value={newCcm.title || ""}
        onChange={(e) => setNewCcm({ ...newCcm, title: e.target.value })}
      />
      <textarea
        placeholder="Descriere"
        value={newCcm.description || ""}
        onChange={(e) => setNewCcm({ ...newCcm, description: e.target.value })}
      />
      <input
        type="file"
        accept="application/pdf"
        onChange={async (e) => {
          const file = e.target.files?.[0];
          if (file) {
            const url = await handlePdfUpload(file);
            setNewCcm((prev) => ({ ...prev, pdf_url: url }));
          }
        }}
      />
      <button onClick={addNewCcm}>Adaugă</button>

      <hr />
      <button onClick={saveAll} className="save-btn">Salvează tot</button>
    </div>
  );
};
